import { DateInput, DateTimeInput, Field, NumericInput, TextOutput, TimeInput } from 'Components/Core';
import { DATETIME_INPUT_COLUMN_WIDTH, DateTimeStyle } from 'Components/Layout/Grid/types';
import { RecordGridField } from 'Components/Worksheets/Core';
import { ConstantDryMassEntryOption } from 'Components/Worksheets/MoistureContentWorksheet/types';
import { DateTimeDataFormat } from 'Lib/Format';

export const airDriedMassGridFieldSet = (
  dryMassEntryOption: ConstantDryMassEntryOption,
  dateTimeStyle: DateTimeStyle = DateTimeStyle.Separate
): Array<RecordGridField> => [
  {
    name: 'DateTimeMeasuredLocal',
    component: <Field input={<DateInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
    label: 'Date Measured',
    hidden: dateTimeStyle === DateTimeStyle.Combined,
  },
  {
    name: 'DateTimeMeasuredLocal',
    component: <Field input={<TimeInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
    label: 'Time Measured',
    hidden: dateTimeStyle === DateTimeStyle.Combined,
  },
  {
    name: 'DateTimeMeasuredLocal',
    component: <Field input={<DateTimeInput />} />,
    label: 'Date And Time Measured',
    hidden: dateTimeStyle === DateTimeStyle.Separate,
    width: DATETIME_INPUT_COLUMN_WIDTH,
  },
  {
    name: 'TareAndDryMass',
    component: <Field input={<NumericInput />} />,
    width: 160,
  },
];

export const getOvenDriedMassGridFieldSet = (
  dryMassEntryOption: ConstantDryMassEntryOption,
  dateTimeStyle: DateTimeStyle = DateTimeStyle.Separate
): Array<RecordGridField> => [
  {
    name: 'DateTimeRemovedFromOvenLocal',
    component: <Field input={<DateInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
    hidden: dryMassEntryOption === 'Never' || dateTimeStyle === DateTimeStyle.Combined,
    label: 'Date Out of Oven',
  },
  {
    name: 'DateTimeRemovedFromOvenLocal',
    component: <Field input={<TimeInput />} dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime} />,
    hidden: dryMassEntryOption === 'Never' || dateTimeStyle === DateTimeStyle.Combined,
    label: 'Time Out of Oven',
  },
  {
    name: 'DateTimeRemovedFromOvenLocal',
    component: <Field input={<DateTimeInput />} />,
    hidden: dryMassEntryOption === 'Never' || dateTimeStyle === DateTimeStyle.Separate,
    label: 'Date and Time out of oven',
    width: DATETIME_INPUT_COLUMN_WIDTH,
  },
  {
    name: 'DryingTime',
    component: <Field input={<TextOutput />} />,
    hidden: dryMassEntryOption === 'Never',
  },
  {
    name: 'DrySoilAndContainerMass',
    // We do not show the dry mass calculated from the Tare + Dry mass, so we need to show its messages on this field
    additionalMessagePaths: ['DrySoilMass'],
    component: <Field input={<NumericInput />} />,
    label: 'Tare & Dry Mass (g)', // shortened
  },
];
